import React from 'react'
import { NavLink } from 'react-router-dom'

const Navbar = () => {
  return (
    <header className='header'>
        <NavLink to="/" className="w-20 h-8 rounded-lg bg-white items-center justify-center flex font-bold shadow-md" style={{transition: "transform 0.1s ease",}} onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")} onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}>
            <p className='blue-gradient_text'>SAIRAM</p>
        </NavLink>
        <nav className='flex text-lg gap-7 font-medium'>
            <NavLink to='https://drive.google.com/file/d/1djRnXigGMFdH40ZR3R2kAYhd9u8lkU0b/view' className={({isActive})=>isActive? 'text-blue-500' : 'text-black'} target='_blank' style={{transition: "transform 0.1s ease",}} onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")} onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}>
                Resume
            </NavLink>
            <NavLink to='/socials' className={({isActive})=>isActive? 'text-blue-500' : 'text-black'} style={{transition: "transform 0.1s ease",}} onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")} onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}>
                Socials
            </NavLink>
            <NavLink to='/contact' className={({isActive})=>isActive? 'text-blue-500' : 'text-black'} style={{transition: "transform 0.1s ease",}} onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")} onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}>
                Contact
            </NavLink>
        </nav>
    </header>
  )
}

export default Navbar